import { useHistory } from 'react-router-dom';
import { Icon, withStyles } from 'vopay';
import { Title, Button, BodyText, Dialog } from 'UI';
import { useTranslation } from 'react-i18next';
import styles from './UpgradePlanDialog.module.scss';

type UpgradePlanDialogProps = {
  open: boolean;
  onClose: () => void;
};

const cn = withStyles(styles);

export default function UpgradePlanDialog({ open, onClose }: UpgradePlanDialogProps) {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AccountBalances' });

  return (
    <Dialog open={open} onClose={onClose}>
      <Dialog.Content closeOnEscape closeButton>
        <div className={cn('modalContainer')}>
          <div>
            <Dialog.Title level="3">{t('upgradePlanTitle', { defaultValue: 'Upgrade Your Plan!' })}</Dialog.Title>
            <BodyText className={cn('description')}>
              {t('upgradePlanInfo', { defaultValue: 'Unlock Better Interest Rates with an Upgrade' })}
            </BodyText>
          </div>

          <div className={cn('plan', 'premium')}>
            <Icon icon="calendarPremium" width="84px" height="84px" color="none" />

            <div>
              <Title className={cn('title')} level="6">
                {t('premiumTitle', { defaultValue: 'Premium Plan' })}
              </Title>

              <BodyText className={cn('description')}>
                {t('premiumInfo', {
                  defaultValue:
                    'Earn a higher annual interest rate on your end-of-day balance with a longer lock-in period for greater returns.',
                })}
              </BodyText>
            </div>
          </div>

          <Button
            className={cn('button')}
            colorScheme="primary"
            onClick={() => {
              history.push('/create-tickets');
              onClose();
            }}
          >
            {t('contactSupportButton', { defaultValue: 'Contact Support' })}
          </Button>
        </div>
      </Dialog.Content>
    </Dialog>
  );
}
